import {
  GENERATE_NEW_TOKEN_STARTED,
  GENERATE_NEW_TOKEN_COMPLETED,
  GENERATE_NEW_TOKEN_FAILED,

  CREATE_ACCESS_TOKEN_STARTED,
  CREATE_ACCESS_TOKEN_COMPLETED,
  CREATE_ACCESS_TOKEN_FAILED
} from '@/store/types'

export default {
  namespaced: true,
  modules: {},

  state () {
    return {
      generatedToken: '',
      loading: false,
      error: undefined
    }
  },

  mutations: {
    [GENERATE_NEW_TOKEN_STARTED] (state) {
      state.loading = true
      state.error = undefined
      state.generatedToken = ''
    },
    [GENERATE_NEW_TOKEN_COMPLETED] (state, token) {
      state.generatedToken = token
      state.loading = false
      state.error = undefined
    },
    [GENERATE_NEW_TOKEN_FAILED] (state, err) {
      state.loading = false
      state.error = err
    },

    [CREATE_ACCESS_TOKEN_STARTED] (state) {
      state.loading = true
      state.error = undefined
    },
    [CREATE_ACCESS_TOKEN_COMPLETED] (state) {
      state.loading = false
      state.error = undefined
    },
    [CREATE_ACCESS_TOKEN_FAILED] (state, err) {
      console.error(err)
      state.loading = false
      state.error = err
    }
  },
  actions: {
    async generateNewToken ({ commit, rootState: { client = undefined } }) {
      try {
        commit(GENERATE_NEW_TOKEN_STARTED)
        const { body: { machine_token: machineToken } } = await client.authClient.AuthService.CreateMachineToken({ body: {} })
        commit(GENERATE_NEW_TOKEN_COMPLETED, machineToken)
      } catch (err) {
        console.log(err)
        commit(GENERATE_NEW_TOKEN_FAILED, err)
      }
    },
    async createAccessToken ({ commit, dispatch, rootState: { client = undefined } }, authorizationToken) {
      try {
        commit(CREATE_ACCESS_TOKEN_STARTED)
        const token = await client.authClient.createAccessToken(authorizationToken)
        await dispatch('client/updateAccessToken', {
          accessToken: token.access_token
        }, { root: true })
        commit(CREATE_ACCESS_TOKEN_COMPLETED)
      } catch (err) {
        commit(CREATE_ACCESS_TOKEN_FAILED, err)
      }
    }
  }
}
